import { FaBalanceScale, FaBook, FaBookOpen, FaBriefcaseMedical, FaCalendarAlt, FaChartBar, FaChartLine, FaClock, FaCogs, FaComments, FaCrown, FaExclamationTriangle, FaEye, FaGlobe, FaGraduationCap, FaHandHolding, FaHandHoldingHeart, FaHandshake, FaHandsHelping, FaHeartbeat, FaIdCard, FaLightbulb, FaMapMarkedAlt, FaNetworkWired, FaPencilRuler, FaPuzzlePiece, FaRandom, FaSeedling, FaShieldAlt, FaStar, FaSyncAlt, FaTasks, FaTrophy, FaUserFriends, FaUserGraduate, FaUsers, FaUserTie } from "react-icons/fa";
import Breadcrumb from "../Breadcrumb";
import ClientsSection from "../../Home/clients-section";
import ServiceRegister from "./components/leadership-solutions/service-register";

import { useState } from "react";
import Certification from "../../../assets/used-images/hr-certification.png";
import IvoryGold from "../../../assets/used-icons/IvoryGold.svg";
import VideoOne from "../../../assets/used-vids/final.mp4";
import {
    TvMinimal,
    ClipboardList,
    Gauge,
    Users,
    BookOpen,
    Cloud,
} from "lucide-react";
// import Image from "../../ui/Image";
import { useTranslation } from 'react-i18next';
import ServiceApplyBtn from "../../ui/ServiceApplyBtn";

export default function LeadershipSoltions() {
    const { t } = useTranslation();
    const [triggeredSection, setTriggeredSection] = useState(0);
    const [seeBox, setSeeBox] = useState(false);

    const dimensionsIcons = [
        // Leadership dimension icons
        <FaBookOpen />,
        <FaBalanceScale />,
        <FaPencilRuler />,
        <FaStar />,
        <FaHandHoldingHeart />,
        <FaComments />,
        <FaHandshake />,
        <FaExclamationTriangle />,

        // Vision dimension icons
        <FaChartLine />,
        <FaShieldAlt />,
        <FaSyncAlt />,
        <FaStar />, // Duplicate - الإلهام
        <FaLightbulb />,
        <FaEye />,
        <FaLightbulb />, // Duplicate - الابتكار
        <FaCrown />,

        // Achievement dimension icons
        <FaHeartbeat />,
        <FaChartBar />,
        <FaBriefcaseMedical />,
        <FaGraduationCap />,
        <FaMapMarkedAlt />,
        <FaPuzzlePiece />,
        <FaSeedling />,
        <FaUsers />,
        <FaTrophy />,
        <FaUserTie />,

        // Ownership dimension icons
        <FaLightbulb />, // Duplicate - المبادرة
        <FaChartLine />, // Duplicate - الدراسة والتحليل
        <FaCogs />,
        <FaUsers />, // Duplicate - تمكين الكوادر
        <FaBook />,
        <FaClock />,
        <FaRandom />,
        <FaExclamationTriangle />, // Duplicate - علاج المشكلات
        <FaLightbulb />, // Duplicate - التفكير الناقد
        <FaHandsHelping />,
        <FaUserGraduate />,
        <FaIdCard />,

        // Collaboration dimension icons
        <FaUsers />, // Duplicate - العمل الجماعي
        <FaNetworkWired />,
        <FaTasks />,
        <FaHandHolding />,
        <FaUserFriends />,
        <FaGlobe />,
        <FaHandshake />, // Duplicate - إدارة علاقات العملاء
        <FaHandshake />, // Duplicate - التفاوض
        <FaCalendarAlt />,
        <FaComments />, // Duplicate - التواصل
        <FaBalanceScale /> // Duplicate - إدارة النزاع
    ];

    const dimensions = t('leadership.dimensions', { returnObjects: true });
    const programLevels = t('leadership.programLevels', { returnObjects: true });
    const instituteInfos = t('leadership.instituteInfos', { returnObjects: true });
    const coreSkills = t('leadership.coreSkills', { returnObjects: true });
    const mainSkillsArray = t('leadership.mainSkillsArray', { returnObjects: true });
    const trainingFeatures = t('leadership.trainingFeatures', { returnObjects: true });

    const trainingFeaturesIcons = [
        <ClipboardList size={25} />,
        <Gauge size={25} />,
        <Users size={25} />,
        <BookOpen size={25} />,
        <Cloud size={25} />
    ];

    return (
        <>
            <Breadcrumb pages={[t('routes.services'), t('routes.leadership-solutions')]} />
            <main className="container my-8">
                <section className="relative border rounded-lg text-start px-3 py-10">
                    <div className="flex justify-center items-center">
                        <div className="absolute -top-4 bg-primary-tw text-white px-4 !py-3 rounded-xl">
                            {t('leadership.title')}
                        </div>
                    </div>
                    <article className="!px-2 text-center mt-2">
                        {t('leadership.desc')}
                    </article>
                </section>
                {/*  الابعاد القيادية و جدارتها */}
                <section>
                    <div className="grid place-items-center my-4">
                        <p className="services-header flex justify-center after:w-32 after:-bottom-2">
                            {t('leadership.title-2')}
                        </p>
                    </div>
                    <section>
                        <div className="flex justify-center items-center gap-2 scrolling">
                            {
                                dimensions.map((item, i) => (
                                    <button key={i}
                                        className={`px-4 py-1 rounded-md border ${i === triggeredSection ? 'bg-primary-tw text-white' : 'text-slate-400'}`}
                                        onClick={() => setTriggeredSection(i)}>
                                        {item.trigger}
                                    </button>
                                ))
                            }
                        </div>

                        <div className="grid lg:grid-cols-4 gap-4 my-4">
                            {
                                dimensions[triggeredSection].items?.map((item, i) => (
                                    <details className="border p-2 rounded-md hover:bg-secondary-tw/5 transition-all" key={i}>
                                        <summary className="flex items-center gap-2 cursor-pointer">
                                            {dimensionsIcons[i]}
                                            {item.title}
                                        </summary>
                                        <ul className="mt-2 ml-4 text-start text-secondary-tw transition-all">
                                            {item.details.map((detailItem, iItem) => (
                                                <li key={iItem} className="flex items-center gap-2">
                                                    <span>
                                                        <img src={IvoryGold} alt="ivory-icon" />
                                                    </span>
                                                    <span>{detailItem}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </details>
                                ))
                            }
                        </div>
                    </section>
                </section>
                <div>
                    <video className="rounded-md border lg:h-[90dvh] w-full" controls>
                        <source src={VideoOne} type="video/mp4" />
                        Your browser doesn't support this type of video.
                    </video>

                </div>
                {/* program levels */}
                <section className="grid lg:grid-cols-2 xl:grid-cols-4 gap-10 mt-12">
                    {
                        programLevels.map((program, i) => (
                            <div key={i} className="border-2 rounded-lg !p-4 relative grid gap-4 bg-[#e9e9e9]">
                                <div className="flex justify-center items-center">
                                    <div className=" absolute -top-6 bg-secondary-tw text-xl rounded-full size-12 flex justify-center items-center text-white">
                                        0{++i}
                                    </div>
                                </div>
                                <p className="text-common-text m-0">
                                    {program.title}
                                </p>
                                <p className="text-secondary-tw text-lg font-semibold m-0">
                                    {program.subtitle}
                                </p>
                            </div>
                        ))
                    }
                </section>

                {/* معهد القيادة IL */}
                <section className="my-32 relative max-lg:my-24">
                    <div className="bg-secondary-tw rounded-md w-full h-12 text-start text-white px-4 !py-2 text-xl">
                        <p>
                            {t('leadership.il')}
                        </p>
                    </div>
                    <div className=" absolute left-0 -top-7 max-lg:relative max-lg:top-0 max-lg:w-full">
                        <img
                            src={Certification}
                            alt="IL-CERTIFICATION"
                            className="bg-white rounded-md !border-2 p-2 border-b-secondary-tw !border-b-4 max-lg:w-full max-lg:my-2"
                        />
                    </div>
                </section>

                <section className="grid lg:grid-cols-2 gap-8">
                    {
                        instituteInfos.map((info, i) => (
                            <div className="!border-2 !border-b-4 border-b-secondary-tw !p-3 rounded-lg">
                                <h2 className="flex items-center gap-2 text-secondary-tw text-lg font-semibold">
                                    <img src={IvoryGold} alt="ivory-icon" className="w-3" />
                                    <span>{info.title}</span>
                                </h2>
                                <article className="text-start text-common-text">
                                    {info.description}
                                </article>
                            </div>
                        ))
                    }
                </section>
            </main>
            {/* الجدارات المعتمدة */}
            <section className="bg-primary-tw py-8 grid place-items-center p-2">
                <div className="grid place-items-center my-4">
                    <p className="services-header flex justify-center after:w-32 after:-bottom-2 text-white">
                        {t('leadership.title-3')}
                    </p>
                </div>

                <div className="grid place-items-center lg:grid-cols-2 xl:grid-cols-5 gap-8 lg:px-20">
                    {
                        coreSkills.map((skill, i) => (
                            <div key={i} className="border px-4 py-8 rounded-lg text-start relative z-0 w-full text-white">
                                <div className="size-12 flex justify-center items-center rounded-full bg-secondary-tw text-white z-10 absolute -top-5 -right-4">
                                    <p className="text-lg font-bold m-0">
                                        0{++i}
                                    </p>
                                </div>
                                <p className="text-xl font-semibold m-0">
                                    {skill.title}
                                </p>
                                <p className="m-0">
                                    {skill.description}
                                </p>
                            </div>
                        ))
                    }
                </div>
            </section>

            {/* مهارات اساسيه */}
            <section className="container my-8">
                <div className="border rounded-lg p-4 flex flex-col items-center !gap-4">
                    <p className="text-secondary-tw font-semibold text-lg">
                        {t('leadership.title-4')}
                    </p>
                    <p className=" text-slate-400 lg:px-20">
                        {t('leadership.desc-4')}
                    </p>
                </div>
                <div className="grid place-items-center xl:grid-cols-4 lg:grid-cols-2 gap-8 px-4 my-6">
                    {
                        mainSkillsArray.map((skill, i) => (
                            <div key={i} className="border px-4 py-8 rounded-lg text-start relative z-0 w-full text-white bg-secondary-tw">
                                <div className="size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-white z-10 absolute -top-5 -right-4">
                                    <p className="text-lg font-bold text-secondary-tw m-0">
                                        {++i}
                                    </p>
                                </div>
                                <p className="text-xl font-semibold">
                                    {skill}
                                </p>
                            </div>
                        ))
                    }
                </div>

                {/* خدمات منصه التدريب */}
                <div className="border rounded-lg grid lg:grid-cols-3 my-20">
                    <div className="bg-primary-tw p-4 flex flex-col items-center gap-3 rounded-tr-lg text-white">
                        <div className="grid place-items-center rounded-full border-2 border-white p-2 size-12">
                            <TvMinimal size={25} />
                        </div>
                        <p className="text-2xl font-semibold" dangerouslySetInnerHTML={{ __html: t('leadership.title-5') }} />
                    </div>
                    {
                        trainingFeatures.map((box, i) => (
                            <div className="p-4 flex flex-col items-center gap-3 border" key={i}>
                                <div className="grid place-items-center rounded-full border-2 border-secondary-tw text-secondary-tw p-2 size-12">
                                    {trainingFeaturesIcons[i]}
                                </div>
                                <p className="text-xl font-semibold">
                                    {box.title}
                                </p>
                                <p>
                                    {box.description}
                                </p>
                            </div>
                        ))
                    }
                </div>

                {/* عملاء حصلو على البرنامج*/}
                {/* <section className="my-16"> */}
                {/* <div className="grid place-items-center">
                        <p className="services-header grid place-items-center after:w-20 after:-bottom-2">
                            عملاء حصلو على البرنامج
                        </p>
                    </div> */}
                {/* <div>
                        video 
                    </div> */}
                {/* <div className="grid lg:grid-cols-3 !gap-4 !my-4">
                        <div className="w-full rounded-lg border !p-4 grid place-items-center relative">
                            <Image

                            />
                        </div>
                        <div className="w-full rounded-lg border !p-4 grid place-items-center relative">
                            <Image

                            />
                        </div>
                        <div className="w-full rounded-lg border !p-4 grid place-items-center relative">
                            <Image

                            />
                        </div>
                    </div> */}
                {/* </section> */}
                {/* المؤسسات الدولية */}
                <section className="my-8">
                    <div className="grid place-items-center">
                        <p className="services-header grid place-items-center after:w-36 after:-bottom-2">
                            {t('leadership.title-6')}
                        </p>
                    </div>
                    <ClientsSection />
                </section>
            </section>
            <button className="bg-primary-tw px-4 py-2 rounded-lg text-white hover:bg-primary-tw/80" onClick={() => setSeeBox(true)}>
                {t('leadership.order-now')}
            </button>
            {seeBox && <ServiceRegister setState={setSeeBox} />}
            {/* <ServiceApplyBtn serviceId={'10'} serviceName={' التطوير القيادي'}/> */}
           
        </>
    )
}